import { render, staticRenderFns } from "./startPromot.vue?vue&type=template&id=308103b2&scoped=true&"
import script from "./startPromot.vue?vue&type=script&lang=js&"
export * from "./startPromot.vue?vue&type=script&lang=js&"
import style0 from "./startPromot.vue?vue&type=style&index=0&id=308103b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308103b2",
  null
  
)

export default component.exports